module.exports = __webpack_public_path__ + "img/XaaSSliderPlaformKubernetes1.e1851e4.svg";